import { render } from "./ComplementoModal.vue?vue&type=template&id=564dc0f0"
import script from "./ComplementoModal.vue?vue&type=script&lang=js"
export * from "./ComplementoModal.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__